export type DisabledSelection = {
  disabled: boolean;
};

export class S2Selection<T> {
  id: string;
  text: string;
  object: T | null;
  html: string | null;

  constructor(id: string, text: string, object: T | null, html: string | null) {
    this.id = String(id);
    this.text = text;
    this.object = object;
    this.html = html;
  }
}
